// src/pages/countries/Countries.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import CountriesTable from "../../components/countries/CountriesTable";

const Countries = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            {/* data table Countries */}
            <CountriesTable />
        </WrapperSection>
    );
};

export default Countries;
